import { render, staticRenderFns } from "./MeetingTypePermissionList.vue?vue&type=template&id=872c970e&scoped=true&"
import script from "./MeetingTypePermissionList.vue?vue&type=script&lang=js&"
export * from "./MeetingTypePermissionList.vue?vue&type=script&lang=js&"
import style0 from "./MeetingTypePermissionList.vue?vue&type=style&index=0&id=872c970e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "872c970e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VCard,VSelect})
